export default "__VITE_ASSET__BvJB3bL9__"